<template>
  <div class="detail-banner dg-no-photo">
    <van-swipe :autoplay="3000" indicator-color="white" v-if="detailList" class="big-swipe">
      <van-swipe-item v-for="(item,index) in detailList.bannerImage" :key="index">
        <img :src="item.url" alt v-if="item.url">
      </van-swipe-item>   
    </van-swipe>
    <van-icon name="play-circle-o" @click="showVideos" v-if="detailList.video && detailList.video.length > 0"/>
    <div class="video-box" v-if="showVideo">
      <div class="close" @click="close"><van-icon name="cross" /></div>
      <video :src="detailList.video[0].url" controls="controls" autoplay></video>
    </div>  
  </div>
</template>
<script>
// import Swiper from "swiper";
export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: ['detailList'],
  methods: {
    showVideos() {
      this.showVideo = true;
    },
    close() {
      this.showVideo = false;
    }
  }
  
};
</script>
<style lang="scss" >
.detail-banner {
  width: 100%;
  height: 600px;
  position: relative;
  .van-icon{
    font-size: 68px;
    position: absolute;
    bottom: 15px;
    left: 15px;
    color: $fc07;
    &:active{
      color: $fc07
    }
  }
  .video-box{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: black;
    video{
      width: 100%;
      height: auto;
      object-fit: fill;
      margin-top: 100px;
    }
    .close{
      width: 40px;
      height: 40px;
      position: absolute;
      right: 30px;
      top: 40px;
      .van-icon {
        font-size: 38px;
        color: white;
        &:active{
          color: $fc07
        }
      }
    }
  }
  .big-swipe{
    width: 100%;
    height: 100%;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
